import { Text } from '@mantine/core';
import { useCountStore } from '../../store';
import SEO from 'components/SEO';

const AdditionalDetailsPage = () => {
  const count = useCountStore((state) => state.count);
  const incrementCount = useCountStore((state) => state.increment);

  return (
    <>
      <SEO 
        title="Additional Details | Nucleus AI"
        description="Additional details and information for your Nucleus AI account."
      />
      <div>
        Additional Details Page
        <Text>The count is {count}</Text>
        <button onClick={incrementCount}>one up</button>
      </div>
    </>
  );
};

export default AdditionalDetailsPage;
